import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/billing/snapshot';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const { workspace_id: workspaceId } = action.payload || {};
    const qs = workspaceId
      ? `?${new URLSearchParams({ workspace_id: workspaceId }).toString()}`
      : '';
    const response = yield call(
      axios.get,
      `${config.API_URL}/billing/snapshot${qs}`,
      { headers: getLocalUser() },
    );
    // Flask responseJSON wraps as {data: {...}}; unwrap so reducers
    // see a flat snapshot doc.
    yield put(fetchSuccess(response.data?.data ?? response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
